__webpack_require__.p = "/فيلا بوتيك/_next/";